import { render, staticRenderFns } from "./TenantEditProperty.vue?vue&type=template&id=1854fe3a&scoped=true&"
import script from "./TenantEditProperty.vue?vue&type=script&lang=js&"
export * from "./TenantEditProperty.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditProperty.vue?vue&type=style&index=0&id=1854fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854fe3a",
  null
  
)

export default component.exports